module.exports = __webpack_public_path__ + "static/Step1-1ed7d5dced5efcb74aedbab810fcb81f.svg";